import { useState, useCallback } from 'react';
import toast from 'react-hot-toast';
import { bookingService } from '../services/booking';

export interface RefundRequest {
  bookingId: string;
  reason?: string;
}

export const useRefundRequest = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const requestRefund = useCallback(
    async (bookingId: string, reason?: string) => {
      setIsLoading(true);
      setError(null);

      try {
        const data = await bookingService.requestRefund(bookingId, reason);
        toast.success('Refund request submitted successfully');
        return data;
      } catch (err: unknown) {
        const errorMessage =
          err && typeof err === 'object' && 'response' in err && err.response && typeof err.response === 'object' && 'data' in err.response
            ? (err.response.data as { message?: string })?.message
            : err instanceof Error
              ? err.message
              : 'Failed to request refund';
        setError(String(errorMessage));
        toast.error(String(errorMessage));
        throw err;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  return {
    isLoading,
    error,
    requestRefund,
  };
};

export default useRefundRequest;
